export default __webpack_public_path__ + "static/videoBanner-30bdf877a2a32703b8bf52f086a6f65a.png";